var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;fill:url(#SVGID_1_);}\n\t.st1{opacity:0.5;enable-background:new    ;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.4875,
    y1: 4.4875,
    x2: 13.5125,
    y2: 15.5125,
    gradientTransform: "matrix(1 0 0 -1 0 18)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#45ac71"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#45ac71"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,0.2L8,0.2c4.3,0,7.8,3.5,7.8,7.8l0,0c0,4.3-3.5,7.8-7.8,7.8l0,0c-4.3,0-7.8-3.5-7.8-7.8l0,0 C0.2,3.7,3.7,0.2,8,0.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.7,6.1L7.8,11c-0.3,0.3-0.7,0.3-1,0L4.3,8.4C4,8.1,4,7.7,4.3,7.4c0.2-0.3,0.7-0.3,1,0l2,2L10.7,5 c0.3-0.3,0.7-0.3,1,0S12,5.8,11.7,6.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckLight);
export default __webpack_public_path__ + "static/media/check-light.361c2e930461d0aa9c95fde3922cde52.svg";
export { ForwardRef as ReactComponent };